import { useState } from "react";
import { Link } from "react-router-dom";
import Image from "../../Global/Image/Image";
import { getUrlPath } from "../../../helpers/LinkHelper";

/**
 * Product variations (print patterns) selector
 */
const ProductVariations = ({
  variations,
  productData,
  printLabel,
  productPrintHeightOverride,
  productPrintWidthOverride,
}) => {
  const [activeVariationName, setActiveVariationName] = useState(
    productData?.stockPrintDesign || null
  );

  if (!variations || variations.length === 0) {
    return null;
  }

  return (
    <div className="pdp-header__product-prints-wrapper">
      <div className="pdp-header__product-prints-items">
        {/* Current product variation */}
        {productData?.variantSwatchUrl && productData?.stockPrintDesign && (
          <span className="pdp-header__product-print-item active">
            <Image
              src={productData.variantSwatchUrl}
              alt={productData.stockPrintDesign || ""}
              height={productPrintHeightOverride}
              width={productPrintWidthOverride}
            />
          </span>
        )}

        {/* Other variations */}
        {variations.map((item, index) => {
          if (!item.variantSwatchUrl || !item.stockPrintDesign) {
            return null;
          }

          return (
            <Link
              key={`variation_${index}`}
              to={getUrlPath(item.url)}
              className="pdp-header__product-print-item"
              onMouseEnter={() => setActiveVariationName(item.stockPrintDesign)}
              onMouseLeave={() => setActiveVariationName(productData?.stockPrintDesign)}
            >
              <Image
                height={productPrintHeightOverride}
                width={productPrintWidthOverride}
                src={item.variantSwatchUrl}
                alt={item.stockPrintDesign || ""}
              />
            </Link>
          );
        })}
      </div>

      {/* Active variation label */}
      {activeVariationName && printLabel && (
        <span className="pdp-header__product-print-current">
          <span className="pdp-header__product-print-label">{printLabel}:&nbsp;</span>
          <span className="pdp-header__product-print-value">{activeVariationName}</span>
        </span>
      )}
    </div>
  );
};

export default ProductVariations;
